import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const FormRating = ({rate,setRate}) => {
    const handleChange = (event) => {
        setRate(event.target.value);
      };
      return <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
      <InputLabel id="demo-simple-select-standard-label">{rate? rate : "Rating"}</InputLabel>
      <Select
        labelId="demo-simple-select-standard-label"
        id="demo-simple-select-standard"
        value={rate}
        onChange={(e) => handleChange(e)}
        label="rate"
      >
        <MenuItem value={0}>All</MenuItem>
        <MenuItem value={3}>Above 3.5</MenuItem>
        <MenuItem value={4}>Above 4</MenuItem>
        <MenuItem value={5}>Above 4.5</MenuItem>
      </Select>
    </FormControl>;
};

export default FormRating;
